import type { ReactNode } from "react";
import styles from "./status-hint.module.css";

export type StatusHintTone = "success" | "warning" | "neutral" | "danger" | "info";

export function StatusHint({
  icon,
  label,
  tone = "neutral",
  placement = "right",
  focusable = true,
  className = "",
}: {
  icon: ReactNode;
  label: string;
  tone?: StatusHintTone;
  placement?: "right" | "bottom";
  focusable?: boolean;
  className?: string;
}) {
  return (
    <span
      className={`${styles.root} ${styles[tone]} ${className}`.trim()}
      data-placement={placement}
      aria-label={label}
      tabIndex={focusable ? 0 : undefined}
    >
      <span className={styles.icon} aria-hidden="true">{icon}</span>
      <span className={styles.tooltip} role="tooltip">{label}</span>
    </span>
  );
}
